module.exports = __webpack_public_path__ + "pic/45.9a96789a.png";